export default __webpack_public_path__ + "static/media/rectangle_purple_cut_edge.4dae095b.svg";